import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/_style.scss';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

